var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert alert-dismissible",class:[
    {'alert-solid-warning': _setup.props.warning},
    _setup.props.classes],attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-text"},[_vm._v("\n    "+_vm._s(_setup.props.message)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }